import { MARKETPLACE_STATUS, WORKFLOW_STEPS } from "../constants/marketplaceStatuses";

const semantic = {
  DRAFT: "gray", SUBMITTED: "blue", UNDER_REVIEW: "orange", CLARIFICATION_REQUIRED: "orange",
  AVAILABILITY_VERIFIED: "teal", APPROVED_FOR_NEGOTIATION: "purple", NEGOTIATION_IN_PROGRESS: "purple",
  RATE_AGREED: "green", PENDING_FINAL_APPROVAL: "orange", PURCHASE_APPROVED: "green",
  PURCHASE_REJECTED: "red", PURCHASE_ORDER_CREATED: "purple", AWAITING_RECEIPT: "purple", PARTIALLY_RECEIVED: "teal", RECEIVED: "teal", STOCK_POSTED: "blue",
  COMPLETED: "green", REJECTED: "red", CANCELLED: "gray", QUALITY_REJECTED: "red",
};
const stageByStatus = {
  DRAFT: -1, SUBMITTED: 0, UNDER_REVIEW: 1, CLARIFICATION_REQUIRED: 1, AVAILABILITY_VERIFIED: 2,
  APPROVED_FOR_NEGOTIATION: 3, NEGOTIATION_IN_PROGRESS: 3, RATE_AGREED: 3, PENDING_FINAL_APPROVAL: 4,
  PURCHASE_APPROVED: 4, PURCHASE_ORDER_CREATED: 5, AWAITING_RECEIPT: 5, PARTIALLY_RECEIVED: 6,
  RECEIVED: 6, QUALITY_REJECTED: 7, STOCK_POSTED: 8, COMPLETED: 9,
};
export const statusColor = (status) => semantic[status] || "gray";
export const statusLabel = (status) => String(status || "Unknown").replace(/_/g, " ");
export const workflowStage = (status) => stageByStatus[status] ?? -1;
export { MARKETPLACE_STATUS, WORKFLOW_STEPS };
